var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 float-right",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.isValidPrint || !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.printLineHaul()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.tripdatafound == true) ? _c('div', {
    attrs: {
      "id": "tripsheetContent"
    }
  }, [_c('br'), _vm._v(" "), [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Trip Sheet")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Manual THC : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VendorVehicleTripID) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip Start Date: ")]), _vm._v(" " + _vm._s(_vm._f("momentDate")(_vm.tripdata.TripStartTime)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip End Date: ")]), _vm._v(" " + _vm._s(_vm._f("momentDate")(_vm.tripdata.TripEndTime)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("THC Entry Time :")]), _vm._v(" " + _vm._s(_vm._f("momentTime")(_vm.tripdata.TripStartTime)) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("THC End Time :")]), _vm._v(" " + _vm._s(_vm._f("momentTime")(_vm.tripdata.TripEndTime)))]), _vm._v(" "), (_vm.tripdata.isBiker) ? _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Type : ")]), _vm._v(" Biker")]) : _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle Type : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VehicleName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Type : ")]), _vm._v(" " + _vm._s(_vm.vendortype))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vendor Name : ")]), _vm._v(" " + _vm._s(_vm.tripdata.VendorName ? _vm.tripdata.VendorName : 'NA'))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Current Location : ")]), _vm._v(" " + _vm._s(_vm.currenthub) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Route Name : ")]), _vm._v(" " + _vm._s(_vm.fullConnectionName))]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Vehicle : ")]), _vm._v(_vm._s(_vm.tripdata.VehicleNo) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Driver Name : ")]), _vm._v(" "), (_vm.tripdata.DriverDetails.length > 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.tripdata.DriverDetails[0].DriverName))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip Start Km :")]), _vm._v(" "), (_vm.tripdata.ShipmentDetails.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.tripdata.ShipmentDetails[0].CurrentKM) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Trip End Km : ")]), _vm._v(" "), (_vm.tripdata.ShipmentDetails.length > 1) ? _c('span', [_vm._v(" " + _vm._s(_vm.tripdata.ShipmentDetails[_vm.tripdata.ShipmentDetails.length - 1].CurrentKM))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("No. Of Bags :")]), _vm._v(_vm._s(_vm.shipmentdata.length))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("Driver Mobile Number :")]), _vm._v(" "), (_vm.tripdata.DriverDetails.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.tripdata.DriverDetails[0].Mobile) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('strong', [_vm._v("SR Name & ID :")]), _vm._v(" "), (_vm.tripdata.isBiker) ? _c('span', [_vm._v(_vm._s(_vm.tripdata.srName + " (  " + _vm.tripdata.srId + "  )") + " ")]) : _vm._e()])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Shipment Information ")])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("ShipmentId/Bag No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("No. of Shipments")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Physical Weight")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Chargeable Weight")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Volumetric Weight")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Origin")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Outscan HubName")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Destination")])])]), _vm._v(" "), _vm._l((_vm.shipmentdata), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentcount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.outscanhub))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupname))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.gettotalshipments(_vm.shipmentdata)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalphywt(_vm.shipmentdata))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalcharwt(_vm.shipmentdata))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.gettotalvolwt(_vm.shipmentdata))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total Vol.Wt. :")]), _vm._v(" " + _vm._s(_vm._f("toFixedNum")(_vm.gettotalvolwt(_vm.shipmentdata))))]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Total Phy.Wt. :")]), _vm._v(" " + _vm._s(_vm._f("toFixedNum")(_vm.gettotalphywt(_vm.shipmentdata))))]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "6"
    }
  }, [_c('strong', [_vm._v("Total Bags : ")]), _vm._v(" " + _vm._s(_vm.shipmentdata.length))])]), _vm._v(" "), _c('br'), _c('tr', [_c('td', {
    attrs: {
      "valign": "bottom",
      "colspan": "4",
      "rowspan": "7",
      "height": "100"
    }
  }, [_vm._v("Location Incharge Signature(Origin)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "bottom",
      "colspan": "6",
      "rowspan": "7",
      "height": "100"
    }
  }, [_vm._v("Location Incharge Signature(Destination)")])])], 2)]), _vm._v(" "), _c('h3')]], 2) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_vm._v("No record found")])]), _vm._v(" "), (_vm.tripdatafound == true) ? _c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.isValidPrint || !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.printLineHaul()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]) : _vm._e()], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.showemailpage == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Send Mail"
    },
    model: {
      value: (_vm.showemailpage),
      callback: function($$v) {
        _vm.showemailpage = $$v
      },
      expression: "showemailpage"
    }
  }, [_c('fieldset', [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Send Mail")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSendMailPage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mail ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailId),
      expression: "mailId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('mailId')
    },
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "name": "mailId",
      "id": "mailId",
      "placeholder": "Enter MailId, Use Comma For Multiple MailId's"
    },
    domProps: {
      "value": (_vm.mailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.emailIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.emailIdValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdValidationMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.SendMailFunction
    }
  }, [_vm._v("Send Mail")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset Mail")]), _vm._v(" \n\n                    ")])])])])])])]) : _vm._e()], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be87e94","hasScoped":true}!./src/views/components/TripSheetPrintForBulkFromCurrentTP/TripSheetPrintForBulkFromCurrentTP.html
// module id = 1407
// module chunks = 2